import React from "react";
import { Tooltip } from "@mui/material";
import {
  CUST_TYPE_STATUS_COLORS,
  getCustTypeStatusColor,
  isOnHoldCustType,
} from "utils/customerCustType";

const SUSPENDED_COLOR = "#F44336";

const StatusBox = ({ custType = "Unknown", suspended = 0, size = 32 }) => {
  const baseColor = getCustTypeStatusColor(custType);
  const isSuspended = suspended === 1;
  const onHold = isOnHoldCustType(custType);

  const getTooltipText = () => {
    if (isSuspended && onHold) return `${custType} - On hold (suspended)`;
    if (isSuspended) return `${custType} - Suspended`;
    if (onHold) return `${custType} - On hold`;
    return custType;
  };

  if (!isSuspended) {
    return (
      <Tooltip title={getTooltipText()} arrow>
        <div
          style={{
            width: size,
            height: size,
            backgroundColor: baseColor,
            borderRadius: "4px",
            display: "inline-block",
            cursor: "help",
            border: onHold ? "2px solid #E65100" : undefined,
          }}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={getTooltipText()} arrow>
      <div
        style={{
          width: size,
          height: size,
          display: "inline-flex",
          borderRadius: "4px",
          overflow: "hidden",
          cursor: "help",
          border: onHold ? "2px solid #E65100" : undefined,
        }}
      >
        <div
          style={{
            width: size / 2,
            height: size,
            backgroundColor: baseColor,
          }}
        />
        <div
          style={{
            width: size / 2,
            height: size,
            backgroundColor: SUSPENDED_COLOR,
          }}
        />
      </div>
    </Tooltip>
  );
};

export { CUST_TYPE_STATUS_COLORS };
export default StatusBox;
